<template>
  <form>
    <div class="input-area">
      <BonusValidate :bonusData="bonusData" v-model="synBonusNum" :bonusDescription="bonusDescription"/>
    </div>

    <div slot="modal-footer" class="modal_footer">
      <div class="text-center">
        <b-btn class="hoverFill" @click="handleHide" v-b-modal.discoupon_modal>
          取消
        </b-btn>
        <a class="btn hoverFill btn-secondary" @click="submit">
          確認
        </a>
      </div>
    </div>
  </form>
</template>

<script>
import BonusValidate from '@/components/Validate/BonusValidate';
import discountApi from '@/api/discount';
import { mapMutations, mapGetters } from 'vuex';

export default {
  data() {
    return {
      bonusNum: null,
      bonusDis: '',
      EventMastId: '',
      EventDetlId: '',
      DESCRITPION: '',
      BonusPoints: '',
      DiscTypePoint: '',
      DscSku: '',
      SkuNoPoint: '',
      RbonusPoints: ''
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    bonusData: {
      type: Object,
      required: true
    },
    bonusNumModal: {
      default: null,
      required: false
    },
    index: {
      type: Number,
      required: true
    },
    bonusDescription: {
      type: String,
      required: true
    }
  },
  components: {
    BonusValidate
  },

  computed: {
    ...mapGetters('cart', ['products']),
    // 紅利點數序號
    synBonusNum: {
      get() {
        return this.bonusNumModal;
      },
      set(val) {
        this.$emit('update:bonusNumModal', val);
      }
    },
    // 從vuex來的紅利點數
    bonusNumFromVuex() {
      return this.products[this.index].bonusDefaultNum;
    },

    parseBonusDis() {
      return parseInt(this.bonusDis) || 0;
    }
  },

  methods: {
    ...mapMutations('cart', ['setCartProductsDiscount']),
    handleHide() {
      this.$emit('handleHide');
    },

    calculate() {
      //總抵扣金額
      let minusAmount = this.parseBonusDis;

      //總金額
      let totalPrice = this.product.price * this.product.quantity;

      //實付金額
      let payPrice = this.product.price * this.product.quantity - minusAmount;

      if (payPrice < 0) {
        if (totalPrice - this.parseBonusDis < 0) {
          alert('紅利點數抵扣金額超過');
          return;
        }
        return;
      }

      //資料存進vuex
      this.setCartProductsDiscount({
        index: this.index,
        bonusDis: this.bonusDis,
        bonusDefaultNum: this.synBonusNum,
        minusAmount: minusAmount,
        payPrice: payPrice,
        EventMastId: this.EventMastId,
        EventDetlId: this.EventDetlId,
        DESCRITPION: this.DESCRITPION,
        DiscTypePoint: this.DiscTypePoint,
        DscSku: this.DscSku,
        SkuNoPoint: this.SkuNoPoint,
        RbonusPoints: this.RbonusPoints
      });
    },

    //紅利點數資格查詢
    callQueryRedeemHola() {
      if (this.synBonusNum < 0) {
        alert('未達可折抵點數');
      } else if (this.synBonusNum == 0) {
        this.bonusDis = '';
        this.EventMastId = '';
        this.EventDetlId = '';
        this.DESCRITPION = '';
        this.DiscTypePoint = '';
        this.DscSku = '';
        this.SkuNoPoint = '';
        this.RbonusPoints = '';
        this.calculate();
        this.$emit('handleHide');
      } else {
        discountApi.queryRedeemHola(
          {
            CompanyID: this.product.ClassBranchId.slice(0, 1) + '0',
            BranchId: this.product.BranchRoomID.slice(0, 4),
            bonusPoints: this.synBonusNum
          },
          res => {
            this.bonusDis = res.payoff;
            this.EventMastId = res.event_mast_id;
            this.EventDetlId = res.event_detl_id;
            this.DESCRITPION = res.DESCRITPION;
            this.DiscTypePoint = res.disc_type;
            this.DscSku = res.dsc_sku;
            this.SkuNoPoint = res.dsc_sku;
            this.RbonusPoints = res.RbonusPoints;
            this.calculate();
            this.$emit('handleHide');
          },
          err => {
            alert(err);
            this.resetbonusNum(this.bonusNumFromVuex);
            return;
          }
        );
      }
    },

    //紅利點數驗證失敗,重設紅利點數
    resetbonusNum(val) {
      this.$emit('update:bonusNumModal', val);
    },

    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          alert('欄位輸入有誤');
        } else {
          this.callQueryRedeemHola();
        }
      });
    }
  }
};
</script>
